import { Typography, type TypographyProps } from '@mui/material';

type Props = {
  title: string;
} & Omit<TypographyProps<'h1'>, 'component'>;

export const PageHeader = ({ title, ...rest }: Props) => (
  <Typography variant="h1" {...rest}>
    {title}
  </Typography>
);
